import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 text-center">
      <div className="flex justify-center space-x-4">
        <p>Powered by FoodOrderoo App</p>
        <a
          href="/feedback"
          rel="noopener noreferrer"
          className="text-blue-400 hover:underline"
        >
          Contact Us
        </a>
      </div>
      <div className="mt-4">
        <p>© 2025 Ordero. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
